import './i18n';
import { LEVEL_CRITICAL, ErrorBoundary as RollbarErrorBoundary, Provider as RollbarProvider } from '@rollbar/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import { PostHogProvider } from 'posthog-js/react';
import { posthog } from 'posthog-js';
import App from './App';
import { VersionCheck } from './VersionCheck';
import { rollbarConfig } from './rollbarConfig';
import { config } from './config';
import { dropWhileSuspended } from './analytics/consent';
import { buildPosthogConfig } from './analytics/posthogConfig';
import { installClickLabels } from './analytics/clickLabels';

posthog.init(
  config.VITE_POSTHOG_KEY,
  buildPosthogConfig(
    { api_host: config.VITE_POSTHOG_API, ui_host: config.VITE_POSTHOG_UI },
    window.location.pathname,
    dropWhileSuspended,
  ),
);
installClickLabels();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <RollbarProvider config={rollbarConfig}>
        <RollbarErrorBoundary level={LEVEL_CRITICAL}>
          <Router>
            <App />
          </Router>
          <VersionCheck />
        </RollbarErrorBoundary>
      </RollbarProvider>
    </PostHogProvider>
  </StrictMode>,
);
